import { UnextLogoAndTypeDarkJetblackImage } from '../../../parts/svgImages/UnextLogoAndTypeImage';
import {
  generateHeaderMenuList,
  StyledIcon,
} from '../_helpers/buildHeaderMenuList';
import { BackgroundFilter } from './BackgroundFilter';
import { CloseButton } from './CloseButton';
import { VisibilitySideNavigation } from './VisibilitySideNavigation';
import type { Config } from 'u-next/config';

export const SideNavigation: React.FC<{
  options: Config;
}> = ({ options }) => (
  <VisibilitySideNavigation>
    <div className="fixed inset-0 z-[1000]">
      <BackgroundFilter />
      <div className="fixed inset-y-0 right-0 w-64 translate-x-[0%] animate-slideInLeftToRight overflow-y-scroll pt-20">
        <div className="absolute inset-0 bg-base-100" />
        <CloseButton />
        <nav className="relative">
          <a href={options.VIDEO} className="mx-auto block w-32">
            <UnextLogoAndTypeDarkJetblackImage alt="" />
          </a>
          <div className="cst-side-space mt-16 ">
            <ul className="grid gap-2">
              {generateHeaderMenuList(options).map(({ url, text, icon }) => (
                <li key={url}>
                  <a href={url}>
                    <div className="flex h-12 items-center gap-2">
                      <div className="relative h-full w-10">
                        <div className="absolute inset-0 m-auto size-6">
                          <StyledIcon
                            jsx={icon}
                            className="size-full object-contain"
                          />
                        </div>
                      </div>
                      <div className="text-base1 font-bold cst-halt leading-[1.4] text-main-100">
                        {text}
                      </div>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </VisibilitySideNavigation>
);
